import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.css' // core css.
import 'primereact/resources/themes/lara-light-indigo/theme.css' // theme.
import { useState } from 'react'
import { QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { ThemeProvider } from 'styled-components'
import Base from './BaseLayout'
import { AuthProvider } from './context/Auth/AuthProvider'
import { AuthRequire } from './context/Auth/AuthRequire'

import { FormDataProvider } from './context/CreateProductsContext'
import { ModalTotalProvider } from './context/ModalContext'
import { ProductProvider } from './context/ProductsContext'
import { FlexContainer, GlobalStyleBody } from './GlobalStyle'
import { queryClient } from './hooks/QueryClient'
import { useTheme } from './hooks/toggleTheme'
import CreatedProducts from './pages/CreatedProducts'
import DataSales from './pages/DataSales'
import Expenses from './pages/Expenses'
import Fixed from './pages/Fixeds'
import HomePage from './pages/Home'
import Import from './pages/Import'
import ListProducts from './pages/ListProducts'
import Login from './pages/Login/LoginPage'
import NewPassword from './pages/Login/NewPassword'
import { default as Recover } from './pages/Login/RecoverPassword'
import NotFound from './pages/NotFound'
import Report1 from './pages/Reports/Report1'
import Report2 from './pages/Reports/Report2'
import Sales from './pages/Sales'
import Variables from './pages/Variables'
const App = () => {
  const [openMenu, setOpenMenu] = useState(true)
  const { theme, toggle } = useTheme()
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <GlobalStyleBody />
          <FlexContainer>
            <BrowserRouter>
              <AuthProvider>
                <ProductProvider>
                  <FormDataProvider>
                    <ModalTotalProvider>
                      <Routes>
                        <Route path="*" element={<NotFound />} />
                        <Route element={<Login />} path="/login" />
                        <Route element={<Recover />} path="/login/recover" />
                        <Route element={<NewPassword />} path="/login/newPassword/:id/:token" />
                        <Route
                          element={
                            <AuthRequire>
                              <Base
                                openMenu={openMenu}
                                toggle={toggle}
                                theme={theme}
                                setOpenMenu={setOpenMenu}
                              />
                            </AuthRequire>
                          }
                        >
                          <Route
                            element={
                              <AuthRequire>
                                {' '}
                                <HomePage />
                              </AuthRequire>
                            }
                            index
                            path="/"
                          />

                          <Route
                            element={
                              <AuthRequire>
                                {' '}
                                <Expenses />
                              </AuthRequire>
                            }
                            path="/expenses"
                          />
                          <Route
                            element={
                              <AuthRequire>
                                {' '}
                                <Fixed />
                              </AuthRequire>
                            }
                            path="/fixed"
                          />
                          <Route
                            element={
                              <AuthRequire>
                                {' '}
                                <Variables />
                              </AuthRequire>
                            }
                            path="/variables"
                          />
                          <Route
                            element={
                              <AuthRequire>
                                {' '}
                                <Import />
                              </AuthRequire>
                            }
                            path="/import"
                          />

                          <Route
                            element={
                              <AuthRequire>
                                {' '}
                                <DataSales />
                              </AuthRequire>
                            }
                            path="/new_sales"
                          />
                          <Route
                            element={
                              <AuthRequire>
                                {' '}
                                <Sales />
                              </AuthRequire>
                            }
                            path="/sales"
                          />
                          <Route
                            element={
                              <AuthRequire>
                                {' '}
                                <CreatedProducts />
                              </AuthRequire>
                            }
                            path="/create_products"
                          />
                          <Route
                            element={
                              <AuthRequire>
                                {' '}
                                <Report1 />
                              </AuthRequire>
                            }
                            path="/reports1"
                          />
                          <Route
                            element={
                              <AuthRequire>
                                {' '}
                                <Report2 />
                              </AuthRequire>
                            }
                            path="/reports2"
                          />
                          <Route
                            element={
                              <AuthRequire>
                                {' '}
                                <ListProducts />
                              </AuthRequire>
                            }
                            path="/list_products"
                          />
                        </Route>
                      </Routes>

                      <ToastContainer autoClose={500} position={toast.POSITION.TOP_RIGHT} />
                    </ModalTotalProvider>
                  </FormDataProvider>
                </ProductProvider>
              </AuthProvider>
            </BrowserRouter>
          </FlexContainer>
        </ThemeProvider>
        <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
      </QueryClientProvider>
    </>
  )
}

export default App
